module.exports = __webpack_public_path__ + "img/soundCloud.6e4ebcfd.svg";